import { render } from "./AddCreditsStep.vue?vue&type=template&id=5aa1abb2&scoped=true"
import script from "./AddCreditsStep.vue?vue&type=script&lang=ts"
export * from "./AddCreditsStep.vue?vue&type=script&lang=ts"

import "./AddCreditsStep.vue?vue&type=style&index=0&id=5aa1abb2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5aa1abb2"

export default script